var menuBar = document.getElementById('menu-bar');
var app = document.getElementById('app');

var heroCtaWaypoint = new Waypoint({
  element: app,
  offset: 150,
  handler: function(direction) {
    if (menuBar.className.indexOf('with-cta') > -1) {
      menuBar.className = menuBar.className.replace(' with-cta', '');
    } else {
      menuBar.className += ' with-cta';
    }
  }
});
